export default {
  props: {
    controls: {
      default: true
    },
    source: {
      type: Object,
      default: () => {
        return {
          video_preview: "",
          video_url: ""
        };
      }
    },
    canPlay: {
      type: Boolean,
      default: true
    },
    // 列表首屏可关闭懒加载，避免内部滚动容器首次未派发滚动事件时视频封面不渲染。
    lazy: {
      type: Boolean,
      default: true
    },
    height: {
      default: "400px"
    },
    width: {
      default: "100%"
    }
  },
  data() {
    return {
      doStart: false
    };
  },
  computed: {
    computedStyle() {
      return {
        width: this.width || "100%",
        backgroundColor: "#000",
        height: this.height
      };
    },
    videoSrc() {
      // 列表缩略图阶段不挂载真实视频地址，避免切换菜单后上一页视频预加载继续占用生产环境网络连接。
      const sourceUrl = typeof this.source === "string" ? this.source : this.source?.video_url;
      return this.doStart ? sourceUrl : "";
    },
    videoPreload() {
      // 只有用户真正播放时才允许浏览器预加载视频，普通封面展示只加载轻量缩略图。
      return this.doStart ? "auto" : "none";
    }
  },
  methods: {
    handlePlay() {
      if (this.canPlay && this.$refs.videoPlayer) {
        this.$refs.videoPlayer.play().catch(error => {
          console.log("自动播放被阻止:", error);
          throw new Error(error);
        });
      }
    }
  }
};